import { notification } from "antd";
import DocumentosService from "../api/Documentos/api-documentos";

export const openNotification = ({ titulo, descripcion, placement }: any) => {
  notification.info({
    message: titulo,
    description: descripcion,
    placement,
  });
};

export const saveFile = async (e: any) => {
  if (e.target.files.length > 0) {
    if (
      e.target.files[0].type.trim() === "application/pdf" ||
      e.target.files[0].type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
      e.target.files[0].type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
      e.target.files[0].type === "image/png" ||
      e.target.files[0].type === "image/jpeg"
    ) {
      try {
        let file = e.target.files[0];
        const formData = new FormData();
        formData.append("archivo", file);
        return await DocumentosService.guardarArchivo(formData);
      } catch (error) {
        return console.error(error);
      }
    }
    return openNotification({
      titulo: "Error",
      descripcion: "Solo se permiten archivos PDF, Word y Excel",
      placement: "bottomRight",
    });
  }
};

export const deleteFile = async (filename: string) => {
  try {
    let data = await DocumentosService.eliminarArchivo(filename);
    console.log(data);
  } catch (error) {
    return console.error(error);
  }
}